import React from 'react';

const TransparencySection = () => {
  return (
    <div className="bg-blue-900 p-8 flex flex-col items-center text-white">
      <div className="max-w-6xl mx-auto text-left w-full">
        
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Transparência</h2>
        
        <p className="text-base md:text-lg mb-8 leading-relaxed">
          A Associação Keralty acredita firmemente na importância da total transparência em suas ações. Todos os nossos relatórios financeiros detalhados e de atividades completas estão disponíveis gratuitamente para download, garantindo que você acompanhe de forma clara e objetiva como suas doações são efetivamente transformadas em um impacto real e positivo na comunidade.
        </p>
        
        {/* Botão */}
        <div className="flex justify-center md:justify-start">
          <button className="bg-lime-500 hover:bg-lime-600 text-white text-1xl font-semibold py-3 px-8 rounded-full shadow-lg transition-colors duration-300">
            IR PARA PÁGINA DE TRANSPARÊNCIA
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default TransparencySection;